module.exports = __webpack_public_path__ + "static/tasks_03@2x-1c543d24cc5066fd6f893d71810a1dbf.png";